<template>
    <div :class="classNames" :style="styling">
        <div class="row">
            <div class="col">
                <h1 v-if="subTitle" style="text-transform: uppercase; font-size: .8em; font-weight: bold; color: #d6dae2; padding: 0;">
                    {{ subTitle }}
                    <span v-if="showCount && resultSet">({{ resultSet.total }})</span>
                </h1>
                <slot name="title">
                    <h2 v-if="title" style="display: inline-block;">{{ title }}</h2>
                </slot>
                <ui-progress-circular v-show="isLoading && showLoading" :indeterminate="true" :size="30" style="display:inline-block; margin-left: 1rem;" :stroke="4"  />
                <span class="subtle" v-if="showPosition && (hasResults || showMetaWhenEmpty)">Showing {{ from | formatNumber }} - {{ to | formatNumber }} of {{ resultSet.total | formatNumber }} {{itemType }}</span>
            </div>
            <div :class="pillColClass + ' text-right'">
                <slot></slot>
                <div v-if="hasResults || false === hideNavOnNoPages">
                    <div :class="navigationHolderClasses" :style="navigationHolderStyling">
                        <slot name="pills"></slot>
                        <span v-if="!hideNav">
                            <span :class="'pill pill-sm pill-dark' + (!hasPreviousPages ? ' disabled' : '')" @click="previous()">
                                <i class="material-icons">keyboard_arrow_left</i>
                            </span>
                            <span :class="'pill pill-sm pill-dark' + (!hasMorePages ? ' disabled' : '')" @click="next()">
                                <i class="material-icons">keyboard_arrow_right</i>
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import GlobalFilters from '../filters';
    import { mapActions, mapState, mapGetters } from 'vuex';

    export default {
        props: {
            itemType: {}, title: {}, classes: {}, dataset: {}, showMetaWhenEmpty: {}, 
            hideOnNoPages: {}, hideNavOnNoPages: {}, hideNav: {}, showPosition: {}, subTitle: {}, 
            showLoading: { default: false }, forceLoading: { default: false }, pillColClass : { default: 'col' },
            showCount: { default: true }
        },
        filters: GlobalFilters,
        computed: {
            ...mapGetters({
                previousOffset: 'dataView/previousOffset',
                nextOffset: 'dataView/nextOffset',
                hasMorePages: 'dataView/hasMorePages',
                hasPreviousPages: 'dataView/hasPreviousPages',
                lastResult: 'dataView/lastResult',
                hasResults: 'dataView/hasResults',
            }),
            ...mapState({ 
                resultSet: state => state.dataView.resultSet,
                isBusy: state => state.dataView.isBusy,
            }),
            from() {
                if (this.resultSet.total > 0) {
                    return this.resultSet.from
                }

                return 0
            },
            to() {
                return _.min([this.lastResult, this.resultSet.total]);
            },
            classNames() {
                return 'meta-container no-border ' + (this.classes ? this.classes : '');
            },
            styling() {
                return this.hideOnNoPages && !this.hasMorePages && !this.hasPreviousPages ?
                    'display: none;' :
                    '';
            },
            navigationHolderClasses() {
                return (this.$slots.default ? '' : 'middle');
            },
            navigationHolderStyling() {
                return (this.hasMorePages || this.hasPreviousPages || !this.hideNavOnNoPages) ? 
                    this.$slots.default ? 'margin-top: 10px;' : 'position: absolute; right: 20px; width: 100%;' :
                    'display: none';
            },
            isLoading() {
                return this.showLoading && (this.isBusy || this.forceLoading)
            }
        },
        methods: {
            ...mapActions({
                storeNext: 'dataView/next',
                storePrevious: 'dataView/previous',
                setQueryString: 'dataView/setQueryString',
            }),
            next() {
                this.storeNext();
                this.setQueryString();

                window.scroll({ top: 0, left: 0, behavior: 'smooth' });
            },
            previous() {
                this.storePrevious();
                this.setQueryString();

                window.scroll({ top: 0, left: 0, behavior: 'smooth' });
            }
        }
    }
</script>